
import React from 'react';
import { Route } from 'react-router';

import LoadingSwitch from 'lib/react-router/loading-switch';
import RouteWithSearch from 'lib/react-router/route-with-search';
import RedirectQueryParam from 'lib/react-router/redirect-query-param';

import NotFound from 'four-nets/errors/404/not-found';

import Collections from './collections/collections';
import CollectionLoader from './collection/collection-loader';
import CollectionEditLoader from './collection-edit/collection-edit-loader';

class CollectionsRouter extends React.PureComponent {
    render() {
        return (
            <LoadingSwitch>
                <RedirectQueryParam
                    param='order_by'
                    path='/blogs/collections/:tab?'
                    exact={true}
                    component={Collections}
                />
                <RouteWithSearch
                    path='/blog/:username/collection/:slug/edit'
                    exact={true}
                    component={CollectionEditLoader}
                />
                <RouteWithSearch path='/blog/:username/collection/:slug' exact={true} component={CollectionLoader} />
                <Route component={NotFound} />
            </LoadingSwitch>
        );
    }
}

export default (CollectionsRouter);
